import { html, View } from 'rune-ts';
import klass from './SnsListView.module.scss';
import { htmlIf } from '@services/MarppleShop/shared/util';
import { FooterData } from '@services/MarppleShop/renderApp/components/cells/Footer/Footer.ts';
import {
  YoutubeIcon,
  InstagramIcon,
  XIcon,
  BlogIcon,
  TiktokIcon,
} from '@services/MarppleShop/renderApp/components/atoms/Icon';

export class SnsListView extends View<Pick<FooterData, 'sns'>> {
  override template() {
    const { sns } = this.data;

    return html`
      <div class="${klass.sns_container}">
        ${htmlIf(
          html`<a href="${sns.instagram}" class="${klass.sns_icon}" target="_blank">${InstagramIcon}</a>`,
          !!sns.instagram,
        )}
        ${htmlIf(
          html`<a href="${sns.youtube}" class="${klass.sns_icon}" target="_blank">${YoutubeIcon}</a>`,
          !!sns.youtube,
        )}
        ${htmlIf(
          html`<a href="${sns.twitter}" class="${klass.sns_icon}" target="_blank">${XIcon}</a>`,
          !!sns.twitter,
        )}
        ${htmlIf(
          html`<a href="${sns.naver_blog}" class="${klass.sns_icon}" target="_blank">${BlogIcon}</a>`,
          !!sns.naver_blog,
        )}
        ${htmlIf(
          html`<a href="${sns.tiktok}" class="${klass.sns_icon}" target="_blank">${TiktokIcon}</a>`,
          !!sns.tiktok,
        )}
      </div>
    `;
  }
}
